<div class="attention-content" [class.cancel-mark]="isCancelStatus" [class.attention-line]="attention_flg">
  <caremoni-dynamic-label *ngIf="status_kbn > 0"
    [data] = "kbnText"
    [config]="labelConfig"
  >
  </caremoni-dynamic-label>
</div>